import { RevealOnScroll } from "./RevealOnScroll";

export type ProcessStep = { num: string; title: string; body: string };

export function ProcessFlow({ steps }: { steps: ProcessStep[] }) {
  return (
    <RevealOnScroll>
      <ol className="grid gap-px overflow-hidden rounded-lg border border-rule bg-rule md:grid-cols-2">
        {steps.map((s) => (
          <li key={s.num} className="bg-white p-7">
            <div className="font-mono text-xs tracking-wider text-cyan-deep">{s.num}</div>
            <div className="mt-3 font-display text-xl text-ink">{s.title}</div>
            <p className="mt-3 text-sm leading-relaxed text-ink-3">{s.body}</p>
          </li>
        ))}
      </ol>
    </RevealOnScroll>
  );
}
